import PropTypes from 'prop-types';
import AddToCartButton from '../../../../components/AddToCartButton/Desktop/AddToCartButtonDesktop';
import Warning from '../../../../components/Warning/Warning';
import { noop } from '../../../../utils/noop';
import GenericCalculatorContainer from '../../../GenericCalculatorContainer/GenericCalculatorContainer';
import { useProductQuantitySelection } from './ProductQuantitySelectionContainer/hooks/useProductQuantitySelection';
import { ProductSpecificationsDesktopStyle } from './ProductSpecificationsDesktop.style';

const ProductQuantitySelectionContainer = (props) => {
  const hookData = useProductQuantitySelection(props);

  const {
    shouldShowCalculator,
    shouldShowAddToCart,
    shouldShowError,
    containerClasses,
    addToCartButtonProps,
    calculatorProps,
    warningProps,
  } = hookData;

  return (
    <>
      {shouldShowCalculator && <GenericCalculatorContainer {...calculatorProps} />}
      {shouldShowAddToCart && (
        <div className={containerClasses}>
          <AddToCartButton {...addToCartButtonProps} />
          {shouldShowError && <Warning {...warningProps} />}
        </div>
      )}
      <style jsx>{ProductSpecificationsDesktopStyle}</style>
    </>
  );
};

ProductQuantitySelectionContainer.defaultProps = {
  addToCartButtonVisible: true,
  errorAddingToCart: false,
  isAddToCartInProgress: false,
  handleAddToCart: noop,
  handleRemoveFromCart: noop,
  isRemoveFromCartInProgress: false,
  sizes: [],
  selectedSize: '',
  showLoginForm: false,
  m2AttributeValue: -1,
  layout: 'hardline',
};

ProductQuantitySelectionContainer.propTypes = {
  maxCartQuantity: PropTypes.number.isRequired,
  addToCartButtonVisible: PropTypes.bool,
  errorAddingToCart: PropTypes.bool,
  isAddToCartInProgress: PropTypes.bool,
  handleRemoveFromCart: PropTypes.func,
  isRemoveFromCartInProgress: PropTypes.bool,
  labels: PropTypes.object.isRequired,
  handleAddToCart: PropTypes.func,
  isVendorLogin: PropTypes.bool.isRequired,
  sizes: PropTypes.array,
  selectedSize: PropTypes.string,
  setShowLoginForm: PropTypes.func.isRequired,
  showLoginForm: PropTypes.bool,
  setErrorAddingToCart: PropTypes.func.isRequired,
  m2AttributeValue: PropTypes.number,
  layout: PropTypes.string,
};

export default ProductQuantitySelectionContainer;
export { ProductQuantitySelectionContainer };
